export default {
  page: {
    sidebarTheme: '',
    // blank sidebar background
    onThisPage: true // show an aside by default
  },

  exampleIndex: {
    aside: 'none',
    // do not show aside
    showCards: true,
    // show example cards
    hideFeedback: true // hide feedback module
  },

  full: {
    aside: 'none' // do not show aside
  }
};